import styled from 'styled-components';
import { zIndexValues } from 'utils/styles';

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.093); /* Semi-transparent background */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: ${zIndexValues.loader}; /* Ensure it is on top of other elements */
  color: white; /* Text color */
`;
